import React from "react"

const DebatePlaceholder = () => {
    return (
        <div className="debate-placeholder m-2 p-3 placeholder"/>
    )
}

export default DebatePlaceholder